import { useEffect, useState } from 'react';

/**
 * Indica si el elemento está (o casi está) dentro de su área visible.
 * Sirve para no decodificar el video de recuadros que quedaron fuera del scroll.
 */
export const useInView = (ref, { enabled = true, rootMargin = '120px' } = {}) => {
    const [inView, setInView] = useState(!enabled);

    useEffect(() => {
        if (!enabled) {
            setInView(true);
            return undefined;
        }
        const el = ref.current;
        if (!el) return undefined;
        if (typeof IntersectionObserver === 'undefined') {
            setInView(true);
            return undefined;
        }
        const observer = new IntersectionObserver(
            ([entry]) => setInView(entry.isIntersecting),
            { rootMargin },
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [ref, enabled, rootMargin]);

    return inView;
};
